import jwtDecode from 'jwt-decode';

const checkTokenExpired = (token) => {
  const decodedToken = jwtDecode(token);
  const isTokenExpired = new Date(decodedToken.exp * 1000) < new Date();

  return isTokenExpired;
};

export default checkTokenExpired;
